// Search/data logic for header search (cities, tags, spots)
import { DATA_PATHS } from '../dataPaths.js';
import { fetchWithCache } from '../utils/index.js';
import { getSpotsBySearch, getCitiesList, getTagsForCity } from '../utils/spot-queries.js';
import { clearAllUI } from '../utils/clearAll.js';
import { LOGGING } from '/settings.js';

let citiesList = [];
let availableTags = [];

export async function loadCitiesList() {
    if (citiesList.length > 0) return citiesList;
    try {
        citiesList = await getCitiesList();
        return citiesList;
    } catch (e) {
        citiesList = [];
        return citiesList;
    }
}

export async function fetchTagsForCity(cityId) {
    try {
        availableTags = await getTagsForCity(cityId);
        return availableTags;
    } catch (e) {
        availableTags = [];
        return availableTags;
    }
}

// Internal helper, not exported
function isPointInBounds(lat, lng, bounds) {
    // bounds: [swLat, swLng, neLat, neLng]
    return lat >= bounds[0] && lat <= bounds[2] && lng >= bounds[1] && lng <= bounds[3];
}

// Internal helper, not exported
function getClosestCity(lat, lng, cities) {
    let minDist = Infinity;
    let closest = null;
    for (const city of cities) {
        const bounds = city.bounds;
        // Use center of bounds
        const centerLat = (bounds[0] + bounds[2]) / 2;
        const centerLng = (bounds[1] + bounds[3]) / 2;
        const dist = Math.sqrt(Math.pow(centerLat - lat, 2) + Math.pow(centerLng - lng, 2));
        if (dist < minDist) {
            minDist = dist;
            closest = city;
        }
    }
    return closest;
}

export async function findCityByLocation(lat, lng) {
    const cities = await loadCitiesList();
    let found = null;
    for (const city of cities) {
        if (city.bounds && isPointInBounds(lat, lng, city.bounds)) {
            found = city;
            break;
        }
    }
    if (!found) {
        found = getClosestCity(lat, lng, cities);
    }
    return found;
}

export async function performSearch(citySlug, tagSlugs) {
    try {
        // Use centralized spot querying system
        const spots = await getSpotsBySearch({ city: citySlug, tags: tagSlugs });
        return spots;
    } catch (error) {
        if (LOGGING.ENABLED && LOGGING.GENERAL) console.error('[Header Search] Error performing search:', error);
        return [];
    }
} 